import { createRouter } from './create-router';
import { RouterProvider } from 'react-router-dom';
import { useConfig } from 'providers/config/ConfigProvider';

export const AppRoutes = () => {
  const { routerBasePath: basename } = useConfig();
  return <RouterProvider router={createRouter(basename)} />;
};
